import React from 'react';
import PropTypes from 'prop-types';
import SeatMap from '@weezevent/throne';
import HoverSeat from './hoverSeat';
import ThroneSeatElements, { SeatMapLegend } from './throne-seat-elements';
import css from '../../manual-modal.module.css';

const Map = React.memo(({ availability, selectedSeats, handleHover, currentInventory, handleGroupSelect, handleSelect, hoveredSeat, categories, form }) => {
    return (
        <div className={css['seat-map-container']}>
            <SeatStyles availability={availability} seats={availability?.seats} selectedSeats={selectedSeats} />
            <SeatMap
                showScene={false}
                showPopup={!selectedSeats?.length}
                currentInventory={currentInventory.uuid}
                minimap={false}
                zone={availability}
                onSeatOver={handleHover}
                onSeatsSelected={handleGroupSelect}
                onSeatClicked={handleSelect}
                mapOptions={{
                    showRowNumbers: true,
                    zoomControls: false,
                    offset: false,
                    seatElements: ThroneSeatElements
                }}
                popover={<HoverSeat zone={hoveredSeat} categories={categories} form={form} />}
            />
            <div className={css['legend-container-wrapping']}>
                <SeatMapLegend seats={availability.seats} />
            </div>
        </div>
    );
});

export default Map;

Map.propTypes = {
    availability: PropTypes.object.isRequired,
    rates: PropTypes.array.isRequired
};

export function SeatStyles({ availability, seats, selectedSeats }) {
    let seat_styles = seats.map(seat => {
        let seat_color = availability.seat_categories[seat.category]?.color;
        let color = seat.booking_state !== 'UNAVAILABLE' ? seat_color : '#878c9b';
        let stroke = seat.booking_state === 'LOCKED_FOR_SOCIAL_DISTANCING' && seat_color;

        if (seat.booking_state === 'LOCKED_FOR_SOCIAL_DISTANCING') {
            color = '#FFF';
        }
        return `td[data-seat-id="${seat.uuid}"] svg path {
                fill: ${color};
            stroke: ${stroke};
		}

            td[data-seat-id="${seat.uuid}"] {
                cursor: ${color};
		}
            td[data-seat-id="${seat.uuid}"]:hover svg path {
                fill: ${color} !important;
		}`;
    });

    // Set selected seats styles
    const styles = selectedSeats?.map(seat => {
        return `
            td[data-seat-id="${seat.uuid}"] svg path {
                stroke: ${'#404040'};
			}
            `;
    });
    return <style>{seat_styles.concat(styles)}</style>;
}
